import React from 'react';
import styles from './SilverEnvelopeHero.module.css';

const SilverEnvelopeHero = ({
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  images,
}) => (
  <section className={styles.heroSection}>
    <div className={styles.foilStripe} aria-hidden="true" />

    <div className={styles.inner}>
      <div className={styles.layout}>
        <div className={styles.copyCol}>
          <span className={styles.badge}>{badge}</span>

          <div className={styles.titleBlock}>
            <span className={styles.eyebrow}>{scriptTitle}</span>
            <h1 className={styles.title}>
              {mainTitleLines[0]}
              <span className={styles.titleAccent}>{mainTitleLines[1]}</span>
            </h1>
          </div>

          {kicker && <p className={styles.kicker}>{kicker}</p>}

          <div className={styles.bodyCopy}>
            {descriptions.slice(0, 2).map((text, index) => (
              <p key={index} className={styles.paragraph}>
                {text}
              </p>
            ))}
          </div>

          {features?.length > 0 && (
            <ul className={styles.featureGrid}>
              {features.map((feature, index) => (
                <li key={index} className={styles.featureTile}>
                  <span className={styles.featureDot} aria-hidden="true" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className={styles.mosaicCol}>
          <div className={styles.mosaic}>
            {images[0] && (
              <figure className={styles.tilePrimary}>
                <img src={images[0].src} alt={images[0].alt} />
              </figure>
            )}
            {images[1] && (
              <figure className={styles.tileSecondary}>
                <img src={images[1].src} alt={images[1].alt} />
              </figure>
            )}
            {images[2] && (
              <figure className={styles.tileTertiary}>
                <img src={images[2].src} alt={images[2].alt} />
              </figure>
            )}
          </div>
          <span className={styles.cornerMark} aria-hidden="true" />
        </div>
      </div>
    </div>
  </section>
);

export default SilverEnvelopeHero;
